import _ from 'lodash';
import axios from 'axios';
import { API_HOST } from '../config.env';
import moment from 'moment';

const headers = access => ({
    headers: {
        Accept: 'application/ld+json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access}`
    }
});

export default function execLiveWorker(access, id, callback) {
   return axios.get(`${API_HOST}/api/lives/${id}`, headers(access)).then(response => {
        if(response.status === 200) {
            axios.get(`${API_HOST}/api/matches/${response.data.matchId}`, headers(access)).then(r => {
                if(r.status === 200) {
                    if(!response.data.deleted) {
                        const caches = localStorage.getItem(`/api/lives/${id}`) ? JSON.parse(localStorage.getItem(`/api/lives/${id}`)) : {};
                        const cache_ttl = caches.cache_ttl_expires_at ? caches.cache_ttl_expires_at : moment().add(1, 'week').unix();
                        const newDataLive = _.assignIn(response.data, {match: r.data, cache_ttl_expires_at: cache_ttl });
                        const oldDataLive = JSON.parse(localStorage.getItem(`/api/lives/${id}`));

                        try {
                            if(newDataLive.actions && oldDataLive.actions && newDataLive.actions.length > oldDataLive.actions.length) {
                                //set text to Nouveaux faits de jeu and show button
                                callback.setRefreshButtonText('Nouveaux faits de jeu');
                                callback.setShowRefreshButton(true);
                            }
                            else if(!_.isEqual(oldDataLive.actions, newDataLive.actions)) {
                                //set text to nouvelles mise à jour
                                callback.setRefreshButtonText('Nouvelles mise à jour');
                                callback.setShowRefreshButton(true);
                            }
                            else {
                                callback.fetch();
                            }
                            localStorage.setItem(`/api/lives/${id}`, JSON.stringify(newDataLive));
                            
                        } catch (error) {
                            
                        }
                    }
                    else {
                        callback.cancel(`/api/lives/${id}`,'canceled');
                        if(_.isFunction(callback.refresh)) {
                            callback.refresh(id);
                        }
                    }
                }
            })
        }
    })
}